// Generated by AvenyModelEditor

export interface IRutinInfo {
  rutinID: number;
  rutinKod: string;
  rutinURL: string;
  benamning: string;
  leveransstatus: Leveransstatus;
}

export interface IRutinKeys {
  [key: number]: string;
}

export interface IRutinInfos {
  [key: string]: IRutinInfo;
  rtnSkotselFakt: IRutinInfo;
  rtnGravsatta: IRutinInfo;
  rtnArbetsunderlagSkapa: IRutinInfo;
  rtnArbetsunderlag: IRutinInfo;
  optKGardar: IRutinInfo;
  optStyrvarden: IRutinInfo;
  rtnGravSkotAdm: IRutinInfo;
  rtnKontakter: IRutinInfo;
  rtnFasttidsavtAvr: IRutinInfo;
  optSkotsellistor: IRutinInfo;
  rtnSkotselExport: IRutinInfo;
  optGravlistor: IRutinInfo;
  rtnGamlaAvtal: IRutinInfo;
  rtnOrderOmg: IRutinInfo;
  rtnAvrakningsavtAvr: IRutinInfo;
  rtnGravarBytKontakt: IRutinInfo;
  rtnFasttidsavtalUppr: IRutinInfo;
  rtnAvrakningsavtKalk: IRutinInfo;
  rtnGravanalys: IRutinInfo;
  rtnBestallningsOrder: IRutinInfo;
  optMallar: IRutinInfo;
  rtnRensaBetansv: IRutinInfo;
  rtnRensaESAvtal: IRutinInfo;
  rtnPubliceraGravsatta: IRutinInfo;
  rtnSkotslar: IRutinInfo;
  rtnGravKartaTeman: IRutinInfo;
  rtnEjSkuldfAvtal: IRutinInfo;
  rtnSkotslar2: IRutinInfo;
  rtnSkotslar3: IRutinInfo;
  rtnGravHandelseLogg: IRutinInfo;
  rtnInformationskiosk: IRutinInfo;
  rtnGravarNollaSaldo: IRutinInfo;
  rtnAvtalFakt: IRutinInfo;
  rtnUtgaendeSkotsel: IRutinInfo;
  rtnExporteraPersonFraga: IRutinInfo;
  rtnSkotselKategorier: IRutinInfo;
  rtnSkotselBestallningar: IRutinInfo;
  rtnGravMyCartaUrval: IRutinInfo;
  rtnGravanordningar: IRutinInfo;
  rtnPubliceradeKartor: IRutinInfo;
  rtnSvenskaGravar: IRutinInfo;
  rtnSekretessGrav: IRutinInfo;
  optHandelseinstallningar: IRutinInfo;
  rtnUsersGA: IRutinInfo;
  rtnUtseGravrattsinnehavare: IRutinInfo;
  optGravrattsinnehavareInstallningar: IRutinInfo;
  optVanvardsarendenInstallningar: IRutinInfo;
  rtnVanvardsarenden: IRutinInfo;
  rtnAktiviteter: IRutinInfo;
  rtnResurser: IRutinInfo;
  rtnGudstjansttyp: IRutinInfo;
  rtnDeltagarlista: IRutinInfo;
  rtnBONummerserier: IRutinInfo;
  rtnAktTypInstallningar: IRutinInfo;
  rtnDeltagare: IRutinInfo;
  rtnResursRubriker: IRutinInfo;
  rtnFakturaOmgang: IRutinInfo;
  rtnOPGrupp: IRutinInfo;
  rtnBegrByra: IRutinInfo;
  rtnVerksamhetstyper: IRutinInfo;
  rtnSammankomst: IRutinInfo;
  rtnBegravningstyp: IRutinInfo;
  rtnAktivitetskategori: IRutinInfo;
  rtnAnnonseras: IRutinInfo;
  rtnGruppmedlemmar: IRutinInfo;
  rtnAnmalningar: IRutinInfo;
  rtnBestallningar: IRutinInfo;
  rtnUsersBO: IRutinInfo;
  rtnResurstyper: IRutinInfo;
  rtnBokningar: IRutinInfo;
  rtnAktdeltagare: IRutinInfo;
  rtnAktkontakt: IRutinInfo;
  rtnTjanstgoring: IRutinInfo;
  rtnPlaneringskategorier: IRutinInfo;
  rtnResursgrupp: IRutinInfo;
  rtnBoknBest: IRutinInfo;
  optBoknBestSettings: IRutinInfo;
  rtnArsbaseradStatistik: IRutinInfo;
  rtnStatistikrapporteringNew: IRutinInfo;
  rtnSekretessBokning: IRutinInfo;
  optPsalmer: IRutinInfo;
  rtnKonteringsmall: IRutinInfo;
  optKontoplan: IRutinInfo;
  rtnKontodel: IRutinInfo;
  rtnVerifikation: IRutinInfo;
  rtnIngBalans: IRutinInfo;
  rtnBudgetVerifikation: IRutinInfo;
  rtnKontoAnalys: IRutinInfo;
  rtnEkonomiRapporter: IRutinInfo;
  rtnAutomatkontering: IRutinInfo;
  rtnSpecEkoRapport: IRutinInfo;
  rtnEKRapportmall: IRutinInfo;
  rtnEKLonefil: IRutinInfo;
  rtnEKImporteraBudget: IRutinInfo;
  rtnBudgetKurva: IRutinInfo;
  rtnEKRapporthuvud: IRutinInfo;
  optMomskod: IRutinInfo;
  rtnUpdateIBWizard: IRutinInfo;
  rtnValjKonteringsbegrepp: IRutinInfo;
  rtnDetaljeringsniva: IRutinInfo;
  rtnEKRapportkategori: IRutinInfo;
  rtnEKRapportpaket: IRutinInfo;
  rtnSIEExport: IRutinInfo;
  rtnKopieraBudget: IRutinInfo;
  rtnKonteringar: IRutinInfo;
  rtnLikviditetsplan: IRutinInfo;
  rtnSIEImport: IRutinInfo;
  rtnOmfordelning: IRutinInfo;
  rtnGavogrupp: IRutinInfo;
  rtnGava: IRutinInfo;
  rtnGavorad: IRutinInfo;
  rtnGavorubrik: IRutinInfo;
  rtnLoneanalys: IRutinInfo;
  rtnVerunderlag: IRutinInfo;
  rtnUsersEK: IRutinInfo;
  rtnFakturahandelser: IRutinInfo;
  rtnBudgetgrupp: IRutinInfo;
  rtnLonetillagg: IRutinInfo;
  rtnPersonalgrupp: IRutinInfo;
  rtnBefattningskod: IRutinInfo;
  rtnAvtalsomrade: IRutinInfo;
  rtnPersonalregister: IRutinInfo;
  rtnPalagg: IRutinInfo;
  rtnBudgetkategori: IRutinInfo;
  rtnArbetsbudget: IRutinInfo;
  rtnArbetsbudgetBudgetgrupp: IRutinInfo;
  rtnArbetsbudgetPersonalregister: IRutinInfo;
  rtnBudgeteringsmodell: IRutinInfo;
  rtnArbetsbudgetrad: IRutinInfo;
  rtnBudgetrutinInstallningar: IRutinInfo;
  rtnArbetsbudgetPersonalbudgetrader: IRutinInfo;
  rtnEKSettings: IRutinInfo;
  rtnKodbehorigheter: IRutinInfo;
  rtnBokforingsmall: IRutinInfo;
  rtnEKLoneart: IRutinInfo;
  rtnTillaggsinfo: IRutinInfo;
  rtnEKLonefilIntern: IRutinInfo;
  rtnEkonomiskAnalys: IRutinInfo;
  rtnAnalysutdelning: IRutinInfo;
  rtnKOBTransTyper: IRutinInfo;
  rtnKOBAterredovisning: IRutinInfo;
  rtnMomsunderlag: IRutinInfo;
  rtnKOBKollektstyrning: IRutinInfo;
  rtnMallarForUtlandskMoms: IRutinInfo;
  rtnTillgang: IRutinInfo;
  rtnRubrik: IRutinInfo;
  rtnByggnaderRum: IRutinInfo;
  rtnAnlKat: IRutinInfo;
  rtnAnlGrupp: IRutinInfo;
  rtnOmrade: IRutinInfo;
  rtnInvestRader: IRutinInfo;
  rtnAutoAvskr: IRutinInfo;
  rtnAutoInternranta: IRutinInfo;
  rtnMakuleraInvrad: IRutinInfo;
  rtnHuvudRubrik: IRutinInfo;
  rtnVisaInvestering: IRutinInfo;
  rtnNyNedskrivning: IRutinInfo;
  rtnNyAvyttr: IRutinInfo;
  rtnPagaendeInvestering: IRutinInfo;
  rtnOmklassificering: IRutinInfo;
  rtnMakuleraAvrakning: IRutinInfo;
  rtnVerksamhetskod: IRutinInfo;
  rtnAtgardskod: IRutinInfo;
  rtnImporteraTillgangar: IRutinInfo;
  rtnKomponent: IRutinInfo;
  rtnByteInvesteringskonto: IRutinInfo;
  rtnInventeringsansvarig: IRutinInfo;
  rtnInventeringsomgang: IRutinInfo;
  rtnFordelningsmall: IRutinInfo;
  rtnForbruknInvRader: IRutinInfo;
  rtnSKVAutoAvskr: IRutinInfo;
  rtnFaktura: IRutinInfo;
  rtnFakturalayout: IRutinInfo;
  rtnSaljare: IRutinInfo;
  rtnFaktureringsgrupp: IRutinInfo;
  rtnKreditorder: IRutinInfo;
  rtnFakturaUppslag: IRutinInfo;
  rtnOrderkategori: IRutinInfo;
  rtnPrisavtal: IRutinInfo;
  rtnOrderrad: IRutinInfo;
  rtnImporteraOrderunderlag: IRutinInfo;
  rtnOrderunderlag: IRutinInfo;
  rtnRantefakturering: IRutinInfo;
  rtnRanteomgang: IRutinInfo;
  rtnOrdermottagningsvag: IRutinInfo;
  rtnScheduler: IRutinInfo;
  rtnFlerbolagshantering: IRutinInfo;
  rtnSIEMottagningsvag: IRutinInfo;
  rtnUsersMall: IRutinInfo;
  rtnKremationsjournal: IRutinInfo;
  optKrematorie: IRutinInfo;
  optBegravningsplats: IRutinInfo;
  optKGardAnnanOrt: IRutinInfo;
  optKremRapportLayout: IRutinInfo;
  optKremlistor: IRutinInfo;
  rtnAktuellaKremationer: IRutinInfo;
  rtnSekretessKremation: IRutinInfo;
  rtnKundkategori: IRutinInfo;
  rtnManuellInbetalning: IRutinInfo;
  rtnBokforingsjournal: IRutinInfo;
  rtnKund: IRutinInfo;
  rtnAutomatiskInbetalning: IRutinInfo;
  rtnKreditering: IRutinInfo;
  rtnUtbetalningtillgodohavande: IRutinInfo;
  rtnMakuleraHandelseKund: IRutinInfo;
  rtnBeraknaTillgodoranta: IRutinInfo;
  rtnKravutskrift: IRutinInfo;
  rtnKrKontoAvstamning: IRutinInfo;
  rtnBetalaKontofaktura: IRutinInfo;
  rtnRegleraInternfakturor: IRutinInfo;
  rtnMedgivande: IRutinInfo;
  rtnAutogirobet: IRutinInfo;
  optMallKund: IRutinInfo;
  rtnKundfakturaanalys: IRutinInfo;
  rtnKravomgang: IRutinInfo;
  rtnKundfakturabunt: IRutinInfo;
  rtnBetalningsfiler: IRutinInfo;
  rtnInbetalningsvag: IRutinInfo;
  rtnLicenser: IRutinInfo;
  rtnUtbetalningKreditfaktura: IRutinInfo;
  rtnKundfakturahandelser: IRutinInfo;
  rtnAterrappAgresso: IRutinInfo;
  rtnAterrappOrderDynamic: IRutinInfo;
  rtnUsers: IRutinInfo;
  rtnRoller: IRutinInfo;
  rtnAvenyGrupper: IRutinInfo;
  rtnNummerserier: IRutinInfo;
  rtnRanteTabell: IRutinInfo;
  rtnMoms: IRutinInfo;
  rtnBokfar: IRutinInfo;
  rtnBank: IRutinInfo;
  rtnKravrutin: IRutinInfo;
  rtnBetalningsvillkor: IRutinInfo;
  rtnBetalningssatt: IRutinInfo;
  rtnLeveransvillkor: IRutinInfo;
  rtnValuta: IRutinInfo;
  rtnLand: IRutinInfo;
  rtnSprak: IRutinInfo;
  rtnTitlar: IRutinInfo;
  optLKF: IRutinInfo;
  rtnUtbetalningssatt: IRutinInfo;
  rtnUtbetalningsvag: IRutinInfo;
  rtnBokningsgrupper: IRutinInfo;
  rtnSystemOrg: IRutinInfo;
  rtnNummerserierUpd: IRutinInfo;
  rtnRapportLayout: IRutinInfo;
  rtnLogg: IRutinInfo;
  rtnKonteringskod: IRutinInfo;
  rtnUndo: IRutinInfo;
  rtnAutogiromall: IRutinInfo;
  rtnPostnr: IRutinInfo;
  rtnUrval: IRutinInfo;
  rtnArbetsstalle: IRutinInfo;
  rtnEkostyr: IRutinInfo;
  rtnFaktGruppSkotsel: IRutinInfo;
  rtnKnavUpdate: IRutinInfo;
  rtnBlankettStyr: IRutinInfo;
  rtnVisaRapporter: IRutinInfo;
  rtnVisaUrval: IRutinInfo;
  rtnClearingArtiklar: IRutinInfo;
  rtnFakturaformedlare: IRutinInfo;
  rtnFakturakoder: IRutinInfo;
  rtnFakturaradskoder: IRutinInfo;
  rtnSystemSettings: IRutinInfo;
  rtnBevakning: IRutinInfo;
  rtnImportXML: IRutinInfo;
  rtnExportXML: IRutinInfo;
  rtnPublishNews: IRutinInfo;
  rtnTestSKK: IRutinInfo;
  rtnKOBIntegration: IRutinInfo;
  rtnRensaSKK: IRutinInfo;
  rtnTestXbridge: IRutinInfo;
  rtnCommunicator: IRutinInfo;
  rtnUDs: IRutinInfo;
  rtnKommunikationsfil: IRutinInfo;
  rtnUppdateraGASStandard: IRutinInfo;
  rtnIgangkorningGAS: IRutinInfo;
  rtnFramsidan: IRutinInfo;
  rtnFormedlingsuppdrag: IRutinInfo;
  rtnKonverteringar: IRutinInfo;
  rtnAdressanvandning: IRutinInfo;
  rtnRegisterutdrag: IRutinInfo;
  rtnGDPRInventering: IRutinInfo;
  rtnGDPRPersonkategorier: IRutinInfo;
  rtnNyckeltal: IRutinInfo;
  rtnProcesser: IRutinInfo;
  rtnStatistikinstallningar: IRutinInfo;
  rtnJobb: IRutinInfo;
  rtnIntegrationMedFlex: IRutinInfo;
  rtnPersonlogg: IRutinInfo;
  rtnJobbA: IRutinInfo;
  rtnIgangkorningEjGAS: IRutinInfo;
  rtnSYSOptions: IRutinInfo;
  rtnDigitalaSigneringar: IRutinInfo;
  rtnGASOut: IRutinInfo;
  rtnTest1: IRutinInfo;
  rtnTest2: IRutinInfo;
  rtnTest3: IRutinInfo;
  rtnTest4: IRutinInfo;
  rtnTest5: IRutinInfo;
  rtnTest6: IRutinInfo;
  rtnTest7: IRutinInfo;
  rtnTest8: IRutinInfo;
  rtnTest9: IRutinInfo;
  rtnTest10: IRutinInfo;
  rtnDemo1: IRutinInfo;
  rtnOrgPersLok: IRutinInfo;
  rtnOPLInternalRoutine: IRutinInfo;
  rtnOPLFind: IRutinInfo;
  rtnAdresser_HarUtgatt: IRutinInfo;
  rtnForsamlingar: IRutinInfo;
  rtnAdressbokKontakter: IRutinInfo;
  rtnTvist: IRutinInfo;
  rtnAvliden: IRutinInfo;
  rtnArtiklar: IRutinInfo;
  rtnEnhet: IRutinInfo;
  rtnArtikelgrupp: IRutinInfo;
  rtnPrislista: IRutinInfo;
  rtnFakturatext: IRutinInfo;
  rtnLevkategori: IRutinInfo;
  rtnLeverantorer: IRutinInfo;
  rtnAttestanter: IRutinInfo;
  rtnAnkomstregistrering: IRutinInfo;
  rtnDefinitivbokning: IRutinInfo;
  rtnUtbetalningsuppdrag: IRutinInfo;
  rtnBokfutbet: IRutinInfo;
  rtnMakuleraHandelseLeverantor: IRutinInfo;
  rtnJusteraLevfakturabelopp: IRutinInfo;
  rtnKontoAvstamning: IRutinInfo;
  rtnLRKvartalsStatistik: IRutinInfo;
  rtnAnkregAvstamning: IRutinInfo;
  rtnFakturabunt: IRutinInfo;
  rtnFakturabevakning: IRutinInfo;
  rtnAttestGrupp: IRutinInfo;
  rtnAttestOmrade: IRutinInfo;
  rtnFakturamottagningsvag: IRutinInfo;
  rtnAttestforslag: IRutinInfo;
  rtnLevFakturor: IRutinInfo;
  rtnBetalRedov: IRutinInfo;
  rtnLeverantorBetSatt: IRutinInfo;
  rtnVisaLeverantorsAttester: IRutinInfo;
  rtnMusikstycke: IRutinInfo;
  rtnForfattare: IRutinInfo;
  rtnForkortningar: IRutinInfo;
  rtnMusikgrupper: IRutinInfo;
  rtnUpdateMBAS: IRutinInfo;
  rtnNotarkiv: IRutinInfo;
  rtnFramforanden: IRutinInfo;
  rtnNoter: IRutinInfo;
  rtnForlag: IRutinInfo;
  rtnDatabaslogg: IRutinInfo;
  rtnProgramAndring: IRutinInfo;
  rtnRutinVal: IRutinInfo;
  rtnCreateUpdate: IRutinInfo;
  rtnAndringsLogg: IRutinInfo;
  optVerOptions: IRutinInfo;
  rtnReportFields: IRutinInfo;
  rtnWebSurvey: IRutinInfo;
  rtnFAQ: IRutinInfo;
  rtnUppdatering: IRutinInfo;
  rtnDiarie: IRutinInfo;
  optDiarieplan: IRutinInfo;
  rtnPostlista: IRutinInfo;
  rtnDiariePlan: IRutinInfo;
  rtnHandlaggare: IRutinInfo;
  rtnMottagare: IRutinInfo;
  rtnHandlingstyp: IRutinInfo;
  rtnDokument: IRutinInfo;
  rtnDiariegrupp: IRutinInfo;
  rtnDIStandardText: IRutinInfo;
  rtnDIStandardTextArkiv: IRutinInfo;
  rtnDIListor: IRutinInfo;
  rtnVisaDiarie: IRutinInfo;
  rtnVisaPostlista: IRutinInfo;
  rtnUsersDI: IRutinInfo;
  rtnFaktureringstyp: IRutinInfo;
  rtnTIEnhet: IRutinInfo;
  rtnTIInstallningar: IRutinInfo;
  rtnTidredovisningsparametrar: IRutinInfo;
  rtnVeckoschema: IRutinInfo;
  rtnRapporteringskod: IRutinInfo;
  rtnAnstalld: IRutinInfo;
  rtnTidregistrering: IRutinInfo;
  rtnArbetsuppgifter: IRutinInfo;
  rtnTidGrupp: IRutinInfo;
  rtnTIProjekt: IRutinInfo;
  rtnPrioritet: IRutinInfo;
  rtnTidrapporteringar: IRutinInfo;
  rtnManadsAvslut: IRutinInfo;
  rtnLoneartKategori: IRutinInfo;
  rtnAnstalldKategori: IRutinInfo;
  rtnInloggningsStatus: IRutinInfo;
  rtnStampelklocka: IRutinInfo;
  rtnRapporteringskod2: IRutinInfo;
  rtnDagschema: IRutinInfo;
  rtnTidbank: IRutinInfo;
  rtnBokforTidrapporteringar: IRutinInfo;
  rtnVarningstyper: IRutinInfo;
  rtnVarningslista: IRutinInfo;
  rtnAnstalldBegr: IRutinInfo;
  rtnFordelaTid: IRutinInfo;
  rtnPeriodregistrering: IRutinInfo;
  rtnTaBortTidrapportering: IRutinInfo;
  rtnRegistreraForDemo: IRutinInfo;
  rtnTIRapport: IRutinInfo;
  rtnSpecTIRapport: IRutinInfo;
  rtnTIRapportkategori: IRutinInfo;
  rtnTIRapporthuvud: IRutinInfo;
  rtnTIAttest: IRutinInfo;
  rtnTIAttestkategorier: IRutinInfo;
  rtnTIAttestomraden: IRutinInfo;
  rtnLoneunderlag: IRutinInfo;
  rtnLonearter: IRutinInfo;
  rtnRapporteringsobjekt: IRutinInfo;
  rtnTidrapporteringBegr: IRutinInfo;
  rtnPeriodregistreringBegr: IRutinInfo;
  rtnFordelaTidBegr: IRutinInfo;
  rtnPafyllSemDagar: IRutinInfo;
  rtnDagrapporteringar: IRutinInfo;
  rtnSchemaOB: IRutinInfo;
  rtnOBRegistrering: IRutinInfo;
  rtnStampel: IRutinInfo;
  rtnWebKontoAnalys: IRutinInfo;
  rtnWebBokfJournal: IRutinInfo;
  rtnWebEKRapport: IRutinInfo;
  rtnWebResultatAnalys: IRutinInfo;
  rtnWebBalansAnalys: IRutinInfo;
  rtnWebBokforder: IRutinInfo;
  rtnWebAttesteraBokforder: IRutinInfo;
  rtnWebBudgetAskandemallar: IRutinInfo;
  rtnWebKalender: IRutinInfo;
  rtnWebStatistikRapportering: IRutinInfo;
  rtnWebForsamlingsStatistik: IRutinInfo;
  rtnWebBoknBestallning: IRutinInfo;
  rtnWebPubliceringsInstIntern: IRutinInfo;
  rtnWebPubliceringsInstExtern: IRutinInfo;
  rtnWebTjanstgoring: IRutinInfo;
  rtnWebBokaGudstjanst: IRutinInfo;
  rtnWebPlanering: IRutinInfo;
  rtnWebFakturaAttest: IRutinInfo;
  rtnWebLeverantorsfakturor: IRutinInfo;
  rtnWebFakturaAttestNyaAvenyTest: IRutinInfo;
  rtnWebTidregistrering: IRutinInfo;
  rtnWebStampelklocka: IRutinInfo;
  rtnBisattningsjournal: IRutinInfo;
  rtnBisattningstyp: IRutinInfo;
  rtnBisattningslokal: IRutinInfo;
  rtnBisattningsUStatus: IRutinInfo;
  rtnBisattningSettings: IRutinInfo;
  rtnBisattningsUStatusUrna: IRutinInfo;
  rtnUsersBJ: IRutinInfo;
  rtnKremBestallningar: IRutinInfo;
  rtnBisattningtransport: IRutinInfo;
  optKremRapportLayoutBJ: IRutinInfo;
  rtnUtskickLogg: IRutinInfo;
  rtnBisattningskontakter: IRutinInfo;
  rtnSekretessBisattning: IRutinInfo;
  rtnWebBisattningsjournal: IRutinInfo;
  rtnWebBisattningsRegister: IRutinInfo;
  rtnWebBisattningsAktAvlidna: IRutinInfo;
  rtnWebBisattningsBestallaKrem: IRutinInfo;
  rtnWebBisattningValjLokal: IRutinInfo;
  rtnWebBisattningKortinlogg: IRutinInfo;
  rtnWebGrav: IRutinInfo;
  rtnWebGravHandelseLogg: IRutinInfo;
  rtnWebGravAnordningar: IRutinInfo;
  rtnWebGravVanvard: IRutinInfo;
  rtnWebMyCarta: IRutinInfo;
  rtnWebOrder: IRutinInfo;
  rtnWebKund: IRutinInfo;
  rtnWebArtikel: IRutinInfo;
  rtnWebPostlista: IRutinInfo;
  rtnWebArende: IRutinInfo;
  rtnWebHandling: IRutinInfo;
  rtnWebInventering: IRutinInfo;
  rtnSecurity: IRutinInfo;
  rtnSupportInfo: IRutinInfo;
  rtnWelcomeInfo: IRutinInfo;
  rtnBestallningInfo: IRutinInfo;
  rtnWelcomeInfoBegrByra: IRutinInfo;
  rtnBestallningInfoGravs: IRutinInfo;
  rtnWebNavet: IRutinInfo;
  rtnGeneric: IRutinInfo;
}

export enum Leveransstatus {
  Active = "Active",
  Beta = "Beta",
  Alfa = "Alfa",
}
